package com.altmann.choresmanager.res.myiconpack

import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Brush.Companion.linearGradient
import androidx.compose.ui.graphics.Brush.Companion.radialGradient
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import com.altmann.choresmanager.res.MyAchievementsPack

public val MyAchievementsPack.Duration12Achievement: ImageVector
    get() {
        if (_duration12Achievement != null) {
            return _duration12Achievement!!
        }
        _duration12Achievement = Builder(name = "Duration12Achievement", defaultWidth = 238.0.dp,
                defaultHeight = 238.0.dp, viewportWidth = 238.0f, viewportHeight = 238.0f).apply {
            path(fill = SolidColor(Color(0xFF1E1E1E)), stroke = null, strokeLineWidth = 0.0f,
                    strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                    pathFillType = NonZero) {
                moveTo(0.0f, 0.0f)
                horizontalLineToRelative(238.0f)
                verticalLineToRelative(238.0f)
                horizontalLineToRelative(-238.0f)
                close()
            }
            group {
                path(fill = SolidColor(Color(0xFF590322)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(238.0f, 0.0f)
                    horizontalLineTo(0.0f)
                    verticalLineTo(238.0f)
                    horizontalLineTo(238.0f)
                    verticalLineTo(0.0f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFFB2104B), 1.0f to Color(0xFF261903),
                        start = Offset(119.0f,-112.8f), end = Offset(119.0f,238.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(0.0f, -112.8f)
                    curveTo(10.58f, -107.18f, 42.97f, -89.66f, 63.47f, -79.09f)
                    curveTo(83.96f, -68.51f, 103.13f, -59.25f, 122.97f, -49.34f)
                    curveTo(142.8f, -39.42f, 163.29f, -28.84f, 182.47f, -19.59f)
                    curveTo(201.64f, -10.33f, 228.74f, 1.9f, 238.0f, 6.2f)
                    verticalLineTo(238.0f)
                    horizontalLineTo(0.0f)
                    verticalLineTo(-112.8f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFFB2104B), 1.0f to Color(0xFF261903),
                        start = Offset(119.0f,-46.72f), end = Offset(119.0f,238.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(0.0f, -46.72f)
                    curveTo(7.27f, -42.97f, 27.11f, -33.71f, 43.63f, -24.23f)
                    curveTo(60.16f, -14.76f, 83.3f, 0.01f, 99.17f, 10.15f)
                    curveTo(115.03f, 20.29f, 124.29f, 29.1f, 138.83f, 36.6f)
                    curveTo(153.38f, 44.09f, 169.91f, 46.96f, 186.43f, 55.11f)
                    curveTo(202.96f, 63.27f, 229.41f, 80.46f, 238.0f, 85.53f)
                    verticalLineTo(238.0f)
                    horizontalLineTo(0.0f)
                    verticalLineTo(-46.72f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFFB2104B), 1.0f to Color(0xFF261903),
                        start = Offset(119.0f,6.97f), end = Offset(119.0f,238.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(0.0f, 6.97f)
                    curveTo(8.59f, 12.48f, 36.36f, 29.68f, 51.57f, 40.04f)
                    curveTo(66.77f, 50.4f, 76.69f, 60.76f, 91.23f, 69.14f)
                    curveTo(105.78f, 77.51f, 121.64f, 81.93f, 138.83f, 90.3f)
                    curveTo(156.02f, 98.68f, 177.84f, 109.04f, 194.37f, 119.4f)
                    curveTo(210.89f, 129.76f, 230.73f, 146.96f, 238.0f, 152.47f)
                    verticalLineTo(238.0f)
                    horizontalLineTo(0.0f)
                    verticalLineTo(6.97f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xA0FFFFFF), 1.0f to Color(0x38FFFFFF),
                        start = Offset(119.0f,182.0f), end = Offset(119.0f,219.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(23.0f, 182.0f)
                    lineTo(215.0f, 182.0f)
                    arcTo(8.0f, 8.0f, 0.0f, false, true, 223.0f, 190.0f)
                    lineTo(223.0f, 211.0f)
                    arcTo(8.0f, 8.0f, 0.0f, false, true, 215.0f, 219.0f)
                    lineTo(23.0f, 219.0f)
                    arcTo(8.0f, 8.0f, 0.0f, false, true, 15.0f, 211.0f)
                    lineTo(15.0f, 190.0f)
                    arcTo(8.0f, 8.0f, 0.0f, false, true, 23.0f, 182.0f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF340000), 0.66f to Color(0xFFD80004),
                        start = Offset(119.5f,218.0f), end = Offset(119.5f,184.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(52.03f, 198.01f)
                    horizontalLineTo(47.05f)
                    curveTo(46.99f, 197.5f, 46.85f, 197.04f, 46.65f, 196.63f)
                    curveTo(46.44f, 196.22f, 46.17f, 195.87f, 45.83f, 195.58f)
                    curveTo(45.49f, 195.29f, 45.09f, 195.06f, 44.63f, 194.91f)
                    curveTo(44.17f, 194.75f, 43.66f, 194.67f, 43.11f, 194.67f)
                    curveTo(42.12f, 194.67f, 41.27f, 194.91f, 40.55f, 195.4f)
                    curveTo(39.84f, 195.88f, 39.29f, 196.58f, 38.91f, 197.5f)
                    curveTo(38.53f, 198.41f, 38.34f, 199.52f, 38.34f, 200.82f)
                    curveTo(38.34f, 202.17f, 38.54f, 203.3f, 38.92f, 204.22f)
                    curveTo(39.31f, 205.13f, 39.86f, 205.81f, 40.56f, 206.28f)
                    curveTo(41.27f, 206.73f, 42.11f, 206.96f, 43.08f, 206.96f)
                    curveTo(43.62f, 206.96f, 44.11f, 206.89f, 44.56f, 206.75f)
                    curveTo(45.01f, 206.62f, 45.4f, 206.41f, 45.74f, 206.15f)
                    curveTo(46.09f, 205.88f, 46.37f, 205.55f, 46.59f, 205.16f)
                    curveTo(46.81f, 204.77f, 46.97f, 204.33f, 47.05f, 203.84f)
                    lineTo(52.03f, 203.87f)
                    curveTo(51.94f, 204.77f, 51.68f, 205.66f, 51.24f, 206.54f)
                    curveTo(50.81f, 207.41f, 50.22f, 208.21f, 49.46f, 208.93f)
                    curveTo(48.7f, 209.65f, 47.78f, 210.22f, 46.7f, 210.64f)
                    curveTo(45.62f, 211.07f, 44.38f, 211.28f, 42.98f, 211.28f)
                    curveTo(41.13f, 211.28f, 39.48f, 210.87f, 38.03f, 210.07f)
                    curveTo(36.57f, 209.25f, 35.43f, 208.06f, 34.59f, 206.51f)
                    curveTo(33.74f, 204.95f, 33.32f, 203.05f, 33.32f, 200.82f)
                    curveTo(33.32f, 198.58f, 33.75f, 196.68f, 34.61f, 195.12f)
                    curveTo(35.46f, 193.56f, 36.62f, 192.38f, 38.08f, 191.57f)
                    curveTo(39.53f, 190.76f, 41.17f, 190.36f, 42.98f, 190.36f)
                    curveTo(44.21f, 190.36f, 45.35f, 190.53f, 46.4f, 190.88f)
                    curveTo(47.44f, 191.21f, 48.37f, 191.71f, 49.16f, 192.37f)
                    curveTo(49.96f, 193.02f, 50.6f, 193.82f, 51.1f, 194.76f)
                    curveTo(51.6f, 195.71f, 51.91f, 196.79f, 52.03f, 198.01f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF340000), 0.66f to Color(0xFFD80004),
                        start = Offset(119.5f,218.0f), end = Offset(119.5f,184.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(59.7f, 202.29f)
                    verticalLineTo(211.0f)
                    horizontalLineTo(54.84f)
                    verticalLineTo(190.64f)
                    horizontalLineTo(59.54f)
                    verticalLineTo(198.53f)
                    horizontalLineTo(59.71f)
                    curveTo(60.06f, 197.59f, 60.62f, 196.85f, 61.4f, 196.32f)
                    curveTo(62.19f, 195.79f, 63.16f, 195.53f, 64.3f, 195.53f)
                    curveTo(65.37f, 195.53f, 66.31f, 195.77f, 67.1f, 196.24f)
                    curveTo(67.9f, 196.71f, 68.51f, 197.38f, 68.95f, 198.24f)
                    curveTo(69.4f, 199.1f, 69.61f, 200.11f, 69.61f, 201.27f)
                    verticalLineTo(211.0f)
                    horizontalLineTo(64.75f)
                    verticalLineTo(202.22f)
                    curveTo(64.75f, 201.37f, 64.54f, 200.71f, 64.11f, 200.23f)
                    curveTo(63.68f, 199.75f, 63.07f, 199.52f, 62.29f, 199.52f)
                    curveTo(61.78f, 199.52f, 61.33f, 199.63f, 60.94f, 199.85f)
                    curveTo(60.55f, 200.07f, 60.25f, 200.39f, 60.03f, 200.8f)
                    curveTo(59.82f, 201.21f, 59.71f, 201.71f, 59.7f, 202.29f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF340000), 0.66f to Color(0xFFD80004),
                        start = Offset(119.5f,218.0f), end = Offset(119.5f,184.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(79.77f, 211.29f)
                    curveTo(78.17f, 211.29f, 76.79f, 210.96f, 75.64f, 210.3f)
                    curveTo(74.49f, 209.64f, 73.6f, 208.72f, 72.98f, 207.54f)
                    curveTo(72.36f, 206.35f, 72.06f, 204.98f, 72.06f, 203.41f)
                    curveTo(72.06f, 201.84f, 72.36f, 200.47f, 72.98f, 199.29f)
                    curveTo(73.6f, 198.1f, 74.49f, 197.18f, 75.64f, 196.52f)
                    curveTo(76.79f, 195.86f, 78.17f, 195.53f, 79.77f, 195.53f)
                    curveTo(81.38f, 195.53f, 82.75f, 195.86f, 83.9f, 196.52f)
                    curveTo(85.05f, 197.18f, 85.94f, 198.1f, 86.55f, 199.29f)
                    curveTo(87.18f, 200.47f, 87.49f, 201.84f, 87.49f, 203.41f)
                    curveTo(87.49f, 204.98f, 87.18f, 206.35f, 86.55f, 207.54f)
                    curveTo(85.94f, 208.72f, 85.05f, 209.64f, 83.9f, 210.3f)
                    curveTo(82.75f, 210.96f, 81.38f, 211.29f, 79.77f, 211.29f)
                    close()
                    moveTo(79.8f, 207.62f)
                    curveTo(80.39f, 207.62f, 80.88f, 207.44f, 81.28f, 207.08f)
                    curveTo(81.69f, 206.72f, 82.0f, 206.23f, 82.21f, 205.59f)
                    curveTo(82.43f, 204.96f, 82.54f, 204.22f, 82.54f, 203.38f)
                    curveTo(82.54f, 202.54f, 82.43f, 201.79f, 82.21f, 201.16f)
                    curveTo(82.0f, 200.52f, 81.69f, 200.02f, 81.28f, 199.66f)
                    curveTo(80.88f, 199.31f, 80.39f, 199.13f, 79.8f, 199.13f)
                    curveTo(79.2f, 199.13f, 78.69f, 199.31f, 78.27f, 199.66f)
                    curveTo(77.86f, 200.02f, 77.54f, 200.52f, 77.33f, 201.16f)
                    curveTo(77.11f, 201.79f, 77.01f, 202.54f, 77.01f, 203.38f)
                    curveTo(77.01f, 204.22f, 77.11f, 204.96f, 77.33f, 205.59f)
                    curveTo(77.54f, 206.23f, 77.86f, 206.72f, 78.27f, 207.08f)
                    curveTo(78.69f, 207.44f, 79.2f, 207.62f, 79.8f, 207.62f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF340000), 0.66f to Color(0xFFD80004),
                        start = Offset(119.5f,218.0f), end = Offset(119.5f,184.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(89.98f, 211.0f)
                    verticalLineTo(195.73f)
                    horizontalLineTo(94.7f)
                    verticalLineTo(198.51f)
                    horizontalLineTo(94.86f)
                    curveTo(95.14f, 197.5f, 95.59f, 196.76f, 96.22f, 196.26f)
                    curveTo(96.85f, 195.77f, 97.59f, 195.52f, 98.42f, 195.52f)
                    curveTo(98.65f, 195.52f, 98.88f, 195.54f, 99.12f, 195.57f)
                    curveTo(99.36f, 195.6f, 99.58f, 195.64f, 99.78f, 195.7f)
                    verticalLineTo(199.92f)
                    curveTo(99.55f, 199.84f, 99.25f, 199.78f, 98.87f, 199.73f)
                    curveTo(98.5f, 199.69f, 98.17f, 199.66f, 97.87f, 199.66f)
                    curveTo(97.3f, 199.66f, 96.78f, 199.79f, 96.31f, 200.05f)
                    curveTo(95.86f, 200.3f, 95.49f, 200.66f, 95.23f, 201.12f)
                    curveTo(94.97f, 201.57f, 94.84f, 202.1f, 94.84f, 202.71f)
                    verticalLineTo(211.0f)
                    horizontalLineTo(89.98f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF340000), 0.66f to Color(0xFFD80004),
                        start = Offset(119.5f,218.0f), end = Offset(119.5f,184.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(108.11f, 211.29f)
                    curveTo(106.51f, 211.29f, 105.13f, 210.97f, 103.97f, 210.34f)
                    curveTo(102.82f, 209.71f, 101.93f, 208.8f, 101.31f, 207.63f)
                    curveTo(100.69f, 206.45f, 100.38f, 205.05f, 100.38f, 203.42f)
                    curveTo(100.38f, 201.85f, 100.7f, 200.47f, 101.32f, 199.29f)
                    curveTo(101.94f, 198.1f, 102.82f, 197.18f, 103.95f, 196.52f)
                    curveTo(105.09f, 195.86f, 106.42f, 195.53f, 107.96f, 195.53f)
                    curveTo(109.05f, 195.53f, 110.04f, 195.7f, 110.94f, 196.04f)
                    curveTo(111.85f, 196.37f, 112.62f, 196.87f, 113.28f, 197.54f)
                    curveTo(113.94f, 198.2f, 114.45f, 199.02f, 114.81f, 199.99f)
                    curveTo(115.18f, 200.96f, 115.36f, 202.07f, 115.36f, 203.32f)
                    verticalLineTo(204.54f)
                    horizontalLineTo(102.08f)
                    verticalLineTo(201.71f)
                    horizontalLineTo(110.83f)
                    curveTo(110.83f, 201.2f, 110.71f, 200.74f, 110.47f, 200.33f)
                    curveTo(110.23f, 199.93f, 109.9f, 199.61f, 109.48f, 199.39f)
                    curveTo(109.07f, 199.15f, 108.6f, 199.04f, 108.06f, 199.04f)
                    curveTo(107.52f, 199.04f, 107.03f, 199.16f, 106.6f, 199.41f)
                    curveTo(106.17f, 199.65f, 105.83f, 199.97f, 105.57f, 200.39f)
                    curveTo(105.32f, 200.8f, 105.19f, 201.27f, 105.18f, 201.79f)
                    verticalLineTo(204.67f)
                    curveTo(105.18f, 205.29f, 105.3f, 205.84f, 105.54f, 206.31f)
                    curveTo(105.79f, 206.77f, 106.14f, 207.13f, 106.59f, 207.39f)
                    curveTo(107.04f, 207.65f, 107.58f, 207.78f, 108.2f, 207.78f)
                    curveTo(108.63f, 207.78f, 109.02f, 207.72f, 109.37f, 207.6f)
                    curveTo(109.72f, 207.48f, 110.03f, 207.3f, 110.28f, 207.07f)
                    curveTo(110.53f, 206.84f, 110.72f, 206.55f, 110.84f, 206.22f)
                    lineTo(115.31f, 206.35f)
                    curveTo(115.12f, 207.35f, 114.72f, 208.22f, 114.09f, 208.96f)
                    curveTo(113.46f, 209.7f, 112.64f, 210.27f, 111.63f, 210.68f)
                    curveTo(110.62f, 211.09f, 109.44f, 211.29f, 108.11f, 211.29f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF340000), 0.66f to Color(0xFFD80004),
                        start = Offset(119.5f,218.0f), end = Offset(119.5f,184.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(123.86f, 211.0f)
                    verticalLineTo(190.64f)
                    horizontalLineTo(128.78f)
                    verticalLineTo(198.81f)
                    horizontalLineTo(136.8f)
                    verticalLineTo(190.64f)
                    horizontalLineTo(141.71f)
                    verticalLineTo(211.0f)
                    horizontalLineTo(136.8f)
                    verticalLineTo(202.82f)
                    horizontalLineTo(128.78f)
                    verticalLineTo(211.0f)
                    horizontalLineTo(123.86f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF340000), 0.66f to Color(0xFFD80004),
                        start = Offset(119.5f,218.0f), end = Offset(119.5f,184.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(151.93f, 211.29f)
                    curveTo(150.33f, 211.29f, 148.95f, 210.96f, 147.8f, 210.3f)
                    curveTo(146.65f, 209.64f, 145.76f, 208.72f, 145.14f, 207.54f)
                    curveTo(144.52f, 206.35f, 144.22f, 204.98f, 144.22f, 203.41f)
                    curveTo(144.22f, 201.84f, 144.52f, 200.47f, 145.14f, 199.29f)
                    curveTo(145.76f, 198.1f, 146.65f, 197.18f, 147.8f, 196.52f)
                    curveTo(148.95f, 195.86f, 150.33f, 195.53f, 151.93f, 195.53f)
                    curveTo(153.54f, 195.53f, 154.91f, 195.86f, 156.06f, 196.52f)
                    curveTo(157.21f, 197.18f, 158.1f, 198.1f, 158.71f, 199.29f)
                    curveTo(159.34f, 200.47f, 159.65f, 201.84f, 159.65f, 203.41f)
                    curveTo(159.65f, 204.98f, 159.34f, 206.35f, 158.71f, 207.54f)
                    curveTo(158.1f, 208.72f, 157.21f, 209.64f, 156.06f, 210.3f)
                    curveTo(154.91f, 210.96f, 153.54f, 211.29f, 151.93f, 211.29f)
                    close()
                    moveTo(151.96f, 207.62f)
                    curveTo(152.54f, 207.62f, 153.04f, 207.44f, 153.44f, 207.08f)
                    curveTo(153.85f, 206.72f, 154.16f, 206.23f, 154.37f, 205.59f)
                    curveTo(154.59f, 204.96f, 154.7f, 204.22f, 154.7f, 203.38f)
                    curveTo(154.7f, 202.54f, 154.59f, 201.79f, 154.37f, 201.16f)
                    curveTo(154.16f, 200.52f, 153.85f, 200.02f, 153.44f, 199.66f)
                    curveTo(153.04f, 199.31f, 152.54f, 199.13f, 151.96f, 199.13f)
                    curveTo(151.36f, 199.13f, 150.85f, 199.31f, 150.43f, 199.66f)
                    curveTo(150.02f, 200.02f, 149.71f, 200.52f, 149.49f, 201.16f)
                    curveTo(149.27f, 201.79f, 149.17f, 202.54f, 149.17f, 203.38f)
                    curveTo(149.17f, 204.22f, 149.27f, 204.96f, 149.49f, 205.59f)
                    curveTo(149.71f, 206.23f, 150.02f, 206.72f, 150.43f, 207.08f)
                    curveTo(150.85f, 207.44f, 151.36f, 207.62f, 151.96f, 207.62f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF340000), 0.66f to Color(0xFFD80004),
                        start = Offset(119.5f,218.0f), end = Offset(119.5f,184.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(171.99f, 204.41f)
                    verticalLineTo(195.73f)
                    horizontalLineTo(176.85f)
                    verticalLineTo(211.0f)
                    horizontalLineTo(172.21f)
                    verticalLineTo(208.16f)
                    horizontalLineTo(172.05f)
                    curveTo(171.71f, 209.09f, 171.14f, 209.83f, 170.32f, 210.38f)
                    curveTo(169.51f, 210.93f, 168.54f, 211.2f, 167.39f, 211.2f)
                    curveTo(166.35f, 211.2f, 165.43f, 210.96f, 164.64f, 210.48f)
                    curveTo(163.86f, 210.01f, 163.24f, 209.34f, 162.8f, 208.48f)
                    curveTo(162.37f, 207.62f, 162.15f, 206.62f, 162.14f, 205.46f)
                    verticalLineTo(195.73f)
                    horizontalLineTo(167.0f)
                    verticalLineTo(204.51f)
                    curveTo(167.01f, 205.34f, 167.23f, 205.99f, 167.66f, 206.47f)
                    curveTo(168.09f, 206.94f, 168.68f, 207.18f, 169.42f, 207.18f)
                    curveTo(169.9f, 207.18f, 170.34f, 207.08f, 170.72f, 206.86f)
                    curveTo(171.11f, 206.65f, 171.42f, 206.33f, 171.64f, 205.92f)
                    curveTo(171.88f, 205.5f, 171.99f, 205.0f, 171.99f, 204.41f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF340000), 0.66f to Color(0xFFD80004),
                        start = Offset(119.5f,218.0f), end = Offset(119.5f,184.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(179.94f, 211.0f)
                    verticalLineTo(195.73f)
                    horizontalLineTo(184.66f)
                    verticalLineTo(198.51f)
                    horizontalLineTo(184.82f)
                    curveTo(185.1f, 197.5f, 185.55f, 196.76f, 186.18f, 196.26f)
                    curveTo(186.81f, 195.77f, 187.55f, 195.52f, 188.38f, 195.52f)
                    curveTo(188.61f, 195.52f, 188.84f, 195.54f, 189.08f, 195.57f)
                    curveTo(189.32f, 195.6f, 189.54f, 195.64f, 189.74f, 195.7f)
                    verticalLineTo(199.92f)
                    curveTo(189.51f, 199.84f, 189.21f, 199.78f, 188.83f, 199.73f)
                    curveTo(188.46f, 199.69f, 188.13f, 199.66f, 187.83f, 199.66f)
                    curveTo(187.26f, 199.66f, 186.74f, 199.79f, 186.27f, 200.05f)
                    curveTo(185.82f, 200.3f, 185.46f, 200.66f, 185.19f, 201.12f)
                    curveTo(184.93f, 201.57f, 184.8f, 202.1f, 184.8f, 202.71f)
                    verticalLineTo(211.0f)
                    horizontalLineTo(179.94f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF340000), 0.66f to Color(0xFFD80004),
                        start = Offset(119.5f,218.0f), end = Offset(119.5f,184.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(205.06f, 200.39f)
                    lineTo(200.59f, 200.51f)
                    curveTo(200.55f, 200.19f, 200.42f, 199.91f, 200.22f, 199.66f)
                    curveTo(200.01f, 199.41f, 199.74f, 199.22f, 199.41f, 199.08f)
                    curveTo(199.09f, 198.93f, 198.71f, 198.86f, 198.28f, 198.86f)
                    curveTo(197.71f, 198.86f, 197.23f, 198.97f, 196.84f, 199.2f)
                    curveTo(196.44f, 199.42f, 196.25f, 199.73f, 196.26f, 200.11f)
                    curveTo(196.25f, 200.41f, 196.37f, 200.67f, 196.62f, 200.89f)
                    curveTo(196.87f, 201.11f, 197.32f, 201.28f, 197.96f, 201.41f)
                    lineTo(200.9f, 201.97f)
                    curveTo(202.43f, 202.26f, 203.56f, 202.75f, 204.3f, 203.42f)
                    curveTo(205.05f, 204.1f, 205.43f, 204.99f, 205.44f, 206.11f)
                    curveTo(205.43f, 207.15f, 205.12f, 208.07f, 204.5f, 208.84f)
                    curveTo(203.89f, 209.62f, 203.06f, 210.22f, 202.0f, 210.65f)
                    curveTo(200.93f, 211.08f, 199.72f, 211.29f, 198.36f, 211.29f)
                    curveTo(196.18f, 211.29f, 194.46f, 210.84f, 193.2f, 209.95f)
                    curveTo(191.94f, 209.04f, 191.23f, 207.84f, 191.05f, 206.33f)
                    lineTo(195.85f, 206.21f)
                    curveTo(195.96f, 206.76f, 196.23f, 207.19f, 196.68f, 207.48f)
                    curveTo(197.12f, 207.77f, 197.69f, 207.92f, 198.38f, 207.92f)
                    curveTo(199.0f, 207.92f, 199.51f, 207.8f, 199.9f, 207.57f)
                    curveTo(200.29f, 207.34f, 200.49f, 207.03f, 200.49f, 206.65f)
                    curveTo(200.49f, 206.3f, 200.34f, 206.02f, 200.04f, 205.82f)
                    curveTo(199.74f, 205.61f, 199.27f, 205.44f, 198.63f, 205.32f)
                    lineTo(195.97f, 204.82f)
                    curveTo(194.44f, 204.54f, 193.3f, 204.02f, 192.55f, 203.27f)
                    curveTo(191.8f, 202.52f, 191.43f, 201.56f, 191.44f, 200.39f)
                    curveTo(191.43f, 199.37f, 191.7f, 198.5f, 192.25f, 197.78f)
                    curveTo(192.8f, 197.05f, 193.58f, 196.49f, 194.6f, 196.1f)
                    curveTo(195.61f, 195.72f, 196.81f, 195.53f, 198.19f, 195.53f)
                    curveTo(200.26f, 195.53f, 201.89f, 195.96f, 203.08f, 196.83f)
                    curveTo(204.27f, 197.69f, 204.93f, 198.88f, 205.06f, 200.39f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFFFEFEF)), stroke = null, fillAlpha = 0.35f,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(69.0f, 148.0f)
                    arcToRelative(50.5f, 6.0f, 0.0f, true, false, 101.0f, 0.0f)
                    arcToRelative(50.5f, 6.0f, 0.0f, true, false, -101.0f, 0.0f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xD3FFFFFF), 1.0f to Color(0x00737373),
                        start = Offset(119.0f,45.5f), end = Offset(119.0f,150.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(86.0f, 43.25f)
                    lineTo(152.0f, 43.25f)
                    arcTo(12.0f, 12.0f, 0.0f, false, true, 164.0f, 55.25f)
                    lineTo(164.0f, 125.0f)
                    arcTo(12.0f, 12.0f, 0.0f, false, true, 152.0f, 137.0f)
                    lineTo(86.0f, 137.0f)
                    arcTo(12.0f, 12.0f, 0.0f, false, true, 74.0f, 125.0f)
                    lineTo(74.0f, 55.25f)
                    arcTo(12.0f, 12.0f, 0.0f, false, true, 86.0f, 43.25f)
                    close()
                }
                path(fill = SolidColor(Color(0xFFD80004)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(74.0f, 55.19f)
                    curveTo(74.0f, 48.56f, 79.37f, 43.19f, 86.0f, 43.19f)
                    horizontalLineTo(152.0f)
                    curveTo(158.63f, 43.19f, 164.0f, 48.56f, 164.0f, 55.19f)
                    verticalLineTo(56.99f)
                    horizontalLineTo(74.0f)
                    verticalLineTo(55.19f)
                    close()
                }
                path(fill = radialGradient(0.0f to Color(0x00ED3AF3), 1.0f to Color(0x42000000),
                        center = Offset(119.0f,50.09f), radius = 40.42f), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(74.0f, 55.19f)
                    curveTo(74.0f, 48.56f, 79.37f, 43.19f, 86.0f, 43.19f)
                    horizontalLineTo(152.0f)
                    curveTo(158.63f, 43.19f, 164.0f, 48.56f, 164.0f, 55.19f)
                    verticalLineTo(56.99f)
                    horizontalLineTo(74.0f)
                    verticalLineTo(55.19f)
                    close()
                }
            }
            group {
                path(fill = SolidColor(Color(0xFFffffff)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(89.91f, 49.85f)
                    arcToRelative(4.11f, 4.28f, 0.0f, true, false, 8.22f, 0.0f)
                    arcToRelative(4.11f, 4.28f, 0.0f, true, false, -8.22f, 0.0f)
                    close()
                }
                path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(90.83f, 49.85f)
                    arcToRelative(3.2f, 3.33f, 0.0f, true, false, 6.4f, 0.0f)
                    arcToRelative(3.2f, 3.33f, 0.0f, true, false, -6.4f, 0.0f)
                    close()
                }
                path(fill = radialGradient(0.27f to Color(0xFFD9D9D9), 0.64f to Color(0xFFA6A6A6),
                        1.0f to Color(0xFF737373), center = Offset(94.03f,44.85f), radius = 7.85f),
                        stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin
                        = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(94.03f, 37.0f)
                    lineTo(94.03f, 37.0f)
                    arcTo(2.74f, 2.74f, 0.0f, false, true, 96.77f, 39.74f)
                    lineTo(96.77f, 49.96f)
                    arcTo(2.74f, 2.74f, 0.0f, false, true, 94.03f, 52.7f)
                    lineTo(94.03f, 52.7f)
                    arcTo(2.74f, 2.74f, 0.0f, false, true, 91.28f, 49.96f)
                    lineTo(91.28f, 39.74f)
                    arcTo(2.74f, 2.74f, 0.0f, false, true, 94.03f, 37.0f)
                    close()
                }
            }
            group {
                path(fill = SolidColor(Color(0xFFffffff)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(140.17f, 49.85f)
                    arcToRelative(4.11f, 4.28f, 0.0f, true, false, 8.22f, 0.0f)
                    arcToRelative(4.11f, 4.28f, 0.0f, true, false, -8.22f, 0.0f)
                    close()
                }
                path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                        strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                        pathFillType = NonZero) {
                    moveTo(141.08f, 49.85f)
                    arcToRelative(3.2f, 3.33f, 0.0f, true, false, 6.4f, 0.0f)
                    arcToRelative(3.2f, 3.33f, 0.0f, true, false, -6.4f, 0.0f)
                    close()
                }
                path(fill = radialGradient(0.27f to Color(0xFFD9D9D9), 0.64f to Color(0xFFA6A6A6),
                        1.0f to Color(0xFF737373), center = Offset(144.28f,44.85f), radius = 7.85f),
                        stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin
                        = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(144.28f, 37.0f)
                    lineTo(144.28f, 37.0f)
                    arcTo(2.74f, 2.74f, 0.0f, false, true, 147.02f, 39.74f)
                    lineTo(147.02f, 49.96f)
                    arcTo(2.74f, 2.74f, 0.0f, false, true, 144.28f, 52.7f)
                    lineTo(144.28f, 52.7f)
                    arcTo(2.74f, 2.74f, 0.0f, false, true, 141.54f, 49.96f)
                    lineTo(141.54f, 39.74f)
                    arcTo(2.74f, 2.74f, 0.0f, false, true, 144.28f, 37.0f)
                    close()
                }
                path(fill = linearGradient(0.34f to Color(0xFFD80004), 1.0f to Color(0xFF340000),
                        start = Offset(118.5f,75.0f), end = Offset(118.5f,114.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(112.48f, 82.73f)
                    verticalLineTo(106.0f)
                    horizontalLineTo(106.86f)
                    verticalLineTo(87.98f)
                    horizontalLineTo(106.73f)
                    lineTo(101.52f, 91.16f)
                    verticalLineTo(86.3f)
                    lineTo(107.26f, 82.73f)
                    horizontalLineTo(112.48f)
                    close()
                }
                path(fill = linearGradient(0.34f to Color(0xFFD80004), 1.0f to Color(0xFF340000),
                        start = Offset(118.5f,75.0f), end = Offset(118.5f,114.0f)), stroke = null,
                        strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(117.62f, 106.0f)
                    verticalLineTo(101.96f)
                    lineTo(126.11f, 94.52f)
                    curveTo(126.75f, 93.95f, 127.29f, 93.42f, 127.74f, 92.94f)
                    curveTo(128.18f, 92.46f, 128.52f, 91.97f, 128.76f, 91.49f)
                    curveTo(128.99f, 91.0f, 129.11f, 90.46f, 129.11f, 89.89f)
                    curveTo(129.11f, 89.24f, 128.97f, 88.69f, 128.69f, 88.24f)
                    curveTo(128.41f, 87.78f, 128.02f, 87.42f, 127.53f, 87.17f)
                    curveTo(127.04f, 86.92f, 126.47f, 86.8f, 125.84f, 86.8f)
                    curveTo(125.19f, 86.8f, 124.63f, 86.93f, 124.14f, 87.19f)
                    curveTo(123.66f, 87.45f, 123.28f, 87.83f, 123.01f, 88.32f)
                    curveTo(122.74f, 88.81f, 122.61f, 89.41f, 122.61f, 90.11f)
                    horizontalLineTo(117.28f)
                    curveTo(117.28f, 88.53f, 117.64f, 87.16f, 118.35f, 86.01f)
                    curveTo(119.06f, 84.86f, 120.06f, 83.97f, 121.35f, 83.35f)
                    curveTo(122.64f, 82.72f, 124.15f, 82.41f, 125.86f, 82.41f)
                    curveTo(127.63f, 82.41f, 129.16f, 82.7f, 130.46f, 83.3f)
                    curveTo(131.77f, 83.89f, 132.77f, 84.71f, 133.49f, 85.77f)
                    curveTo(134.21f, 86.83f, 134.57f, 88.05f, 134.57f, 89.44f)
                    curveTo(134.57f, 90.33f, 134.39f, 91.21f, 134.03f, 92.08f)
                    curveTo(133.68f, 92.95f, 133.04f, 93.91f, 132.11f, 94.97f)
                    curveTo(131.19f, 96.02f, 129.89f, 97.28f, 128.2f, 98.75f)
                    lineTo(125.42f, 101.32f)
                    verticalLineTo(101.47f)
                    horizontalLineTo(134.85f)
                    verticalLineTo(106.0f)
                    horizontalLineTo(117.62f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF340000), 0.73f to Color(0xFFD80004),
                        start = Offset(146.47f,113.94f), end = Offset(162.46f,123.71f)), stroke =
                        null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(153.09f, 123.4f)
                    curveTo(153.28f, 123.08f, 153.72f, 123.08f, 153.91f, 123.4f)
                    lineTo(157.91f, 130.25f)
                    curveTo(158.1f, 130.58f, 157.87f, 131.0f, 157.5f, 131.0f)
                    horizontalLineTo(149.5f)
                    curveTo(149.13f, 131.0f, 148.9f, 130.58f, 149.09f, 130.25f)
                    lineTo(153.09f, 123.4f)
                    close()
                }
                path(fill = linearGradient(0.0f to Color(0xFF340000), 0.73f to Color(0xFFD80004),
                        start = Offset(146.47f,113.94f), end = Offset(162.46f,123.71f)), stroke =
                        null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f, pathFillType = NonZero) {
                    moveTo(153.08f, 124.93f)
                    curveTo(153.27f, 125.26f, 153.73f, 125.26f, 153.92f, 124.93f)
                    lineTo(157.93f, 117.74f)
                    curveTo(158.12f, 117.41f, 157.89f, 117.0f, 157.52f, 117.0f)
                    horizontalLineTo(149.48f)
                    curveTo(149.11f, 117.0f, 148.88f, 117.41f, 149.07f, 117.74f)
                    lineTo(153.08f, 124.93f)
                    close()
                }
            }
        }
        .build()
        return _duration12Achievement!!
    }

private var _duration12Achievement: ImageVector? = null
